module.exports = __webpack_public_path__ + "img/boundary-signal-event.67df855a.svg";